declare const I18n;

import React from "react";

type SkillHeadingProps = {
  skillSlug: string;
};

const SkillHeading: React.FC<SkillHeadingProps> = ({ skillSlug }) => {
  const iconMap: Record<string, string> = {
    growth_mindset: "/BrainBuilder.svg",
    creativity: "/CreativeSpark.svg",
    critical_thinking: "/PuzzleSolver.svg",
    communication: "/SignalBoost.svg",
    collaboration: "/SyncSquad.svg",
    global_citizenship: "/WorldCitizen.svg",
  };


  const iconPath = iconMap[skillSlug];

  return (
    <div className="skills-heading">
      {iconPath && (
        <img
          src={iconPath}
          className="skills-heading__icon"
          width={96}
          height={96}
          alt={`${skillSlug} icon`}
        />
      )}

      <div className="skills-heading__text">
        <p className="skills-heading__title">
          {I18n.t(`models.skills.attributes.${skillSlug}`)}
        </p>

        <p className="skills-heading__description">
          {I18n.t(`models.skills.attributes.${skillSlug}_description`)}
        </p>
      </div>
    </div>
  );
};

export default SkillHeading;
